
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.118 8L8.866 6.766A3.43 3.43 0 009.104 5.5c0-1.934-1.59-3.5-3.552-3.5C3.589 2 2 3.566 2 5.5S3.589 9 5.552 9c.453 0 .885-.084 1.284-.234L8.09 10l-1.253 1.234c-.4-.153-.83-.234-1.284-.234C3.589 11 2 12.566 2 14.5S3.589 18 5.552 18s3.552-1.566 3.552-3.5c0-.447-.086-.872-.238-1.266L17.83 4.4a.558.558 0 000-.8 2.319 2.319 0 00-3.247 0L10.118 8zm.717 4.706l3.749 3.694c.897.884 2.35.884 3.247 0a.558.558 0 000-.8l-4.966-4.894-2.03 2zM7.075 5.5c0 .828-.683 1.5-1.523 1.5-.84 0-1.522-.672-1.522-1.5S4.71 4 5.552 4c.84 0 1.522.672 1.522 1.5zM5.551 16c-.84 0-1.522-.672-1.522-1.5S4.71 13 5.552 13c.84 0 1.522.672 1.522 1.5S6.392 16 5.552 16z","fill":"#999"}})])
          )
        }
      }
    